import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const multiclassImprovementModule = namespace('multiclassImprovements');
let CharactersMulticlassImprovements = class CharactersMulticlassImprovements extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Multiclass Improvements';
    }
    created() {
        this.fetchMulticlassImprovements();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.multiclassImprovements)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(multiclassImprovement => ({
            ...multiclassImprovement,
            id: multiclassImprovement.name,
            isExpandable: multiclassImprovement.description
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    multiclassImprovementModule.State
], CharactersMulticlassImprovements.prototype, "multiclassImprovements", void 0);
__decorate([
    multiclassImprovementModule.Action
], CharactersMulticlassImprovements.prototype, "fetchMulticlassImprovements", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersMulticlassImprovements.prototype, "isInHandbook", void 0);
CharactersMulticlassImprovements = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersMulticlassImprovements);
export default CharactersMulticlassImprovements;
